import { View } from "@aws-amplify/ui-react";
import { orderBy } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import FilterDestinationInput from "../Inputs/FilterDestinationInput";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import { Company, OfficeWithCompanyData } from "../../types/Interfaces";
import OfficesList from "../OfficesList";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

const productOptions = [
    {
        value: "all",
        text: "all",
    },
    {
        value: "pcr",
        text: "PCR",
    },
    {
        value: "antigen",
        text: "antigen",
    },
    {
        value: "vaccine",
        text: "vaccine",
    },
];

const OfficeContent = (props: any) => {
    const { t } = useTranslation();
    const companies = props.companies;

    const [searchkey, setsearchkey] = useState("");
    const [filterkey, setfilterkey] = useState(props.filterkeydefault ? (props.filterkeydefault as string) : "all");

    const changefilterbutton = (event: any) => {
        setfilterkey(event.target.value);
    };

    const sortedOfficesList = orderBy(companies, ["listorder"], ["asc"]).flatMap(
        (company: Company): OfficeWithCompanyData[] => {
            return company.offices.map((office) => {
                return {
                    ...office,
                    companyName: company.companyName,
                    companyId: company.id,
                    companyLogo: company.logo,
                    companyProducts: company.products,
                };
            });
        }
    );

    return (
        <>
            <Grid container spacing={2} alignItems="center" justifyContent="center">
                <Grid item xs={12} lg={6} xl={4} id="what-do-we-do" alignItems="center">
                    <FilterDestinationInput
                        icon={<LanguageOutlinedIcon />}
                        text={t("travel-rules-summary.traveling-from")}
                        onChange={(event) => {
                            setsearchkey(event.target.value);
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2} alignItems="center" justifyContent="center">
                <Grid item xs={12} md={8}>
                    {props.filterdisabled !== "true" ? (
                        <ToggleButtonGroup
                            color="primary"
                            fullWidth
                            exclusive
                            sx={(theme) => ({
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: theme.spacing(1),
                                marginBottom: theme.spacing(4),
                                "& .MuiToggleButtonGroup-grouped:not(:last-of-type), & .MuiToggleButtonGroup-grouped:not(:first-of-type)":
                                    {
                                        borderRadius: theme.spacing(3.75),
                                        borderColor: "transparent",
                                    },
                                "& .MuiToggleButton-root": {
                                    textTransform: "none",
                                    borderRadius: theme.shape.borderRadius,
                                    fontSize: theme.spacing(2.25),
                                    padding: theme.spacing(1.25),
                                    backgroundColor: theme.palette.common.white,
                                    boxShadow: theme.shadows[1],
                                    "&.Mui-selected": {
                                        backgroundColor: theme.palette.primary.light,
                                        color: theme.palette.primary.contrastText,
                                        "&:hover": {
                                            backgroundColor: theme.palette.primary.main,
                                        },
                                    },
                                    "&:hover": {
                                        backgroundColor: theme.palette.action.hover,
                                    },
                                },
                            })}
                            value={filterkey}
                            onChange={(e) => {
                                changefilterbutton(e);
                            }}>
                            {productOptions.map((option) => (
                                <ToggleButton key={option.value} value={option.value}>
                                    {t(option.text)}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    ) : (
                        ""
                    )}
                </Grid>
            </Grid>

            <OfficesList offices={sortedOfficesList} filterBy={filterkey} searchQuery={searchkey} />
        </>
    );
};

export default OfficeContent;
